import FeaturesPage from '@/components/Pages/FeaturesPage';

export default FeaturesPage;
